module.exports = __webpack_public_path__ + "img/lastPage-transformed.ace0ff2c.png";